import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ist-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxRemoteOperations = _resolveComponent("DxRemoteOperations")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.rows,
      ref: "gridRef",
      "key-expr": _ctx.keyExpr,
      "show-borders": true,
      "allow-column-resizing": true,
      "column-auto-width": false,
      height: "100%",
      "show-row-lines": true,
      "hover-state-enabled": true,
      "no-data-text": _ctx.complet ? 'Nu există istoric.' : 'Nu există istoric pentru luna selectată.'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxScrolling, {
          mode: "virtual",
          "column-rendering-mode": "virtual",
          "row-page-size": 100
        }),
        (_ctx.complet)
          ? (_openBlock(), _createBlock(_component_DxRemoteOperations, {
              key: 0,
              paging: true
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DxSorting, { mode: "single" }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 200,
          placeholder: "Caută…"
        }),
        _createVNode(_component_DxExport, {
          enabled: true,
          formats: ['xlsx']
        }),
        (_ctx.complet)
          ? (_openBlock(), _createBlock(_component_DxColumn, {
              key: 1,
              "data-field": "Data",
              caption: "Luna",
              "data-type": "date",
              format: "MM.yyyy",
              width: 80,
              fixed: true,
              "sort-order": "desc"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DxColumn, {
          "data-field": "CodAngajat",
          caption: "Marca",
          width: 80,
          fixed: true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NumeAngajat",
          caption: "Nume",
          width: 200,
          fixed: true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Post",
          caption: "Post",
          width: 160,
          visible: false
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zile, (z) => {
          return (_openBlock(), _createBlock(_component_DxColumn, {
            key: z,
            "data-field": 'Z' + z,
            caption: String(z),
            width: 40,
            alignment: "center",
            "css-class": _ctx.weekendClass(z)
          }, null, 8, ["data-field", "caption", "css-class"]))
        }), 128)),
        _createVNode(_component_DxColumn, {
          "data-field": "Total",
          caption: "Total",
          width: 70,
          fixed: true,
          "fixed-position": 'right',
          alignment: "center",
          "css-class": "col-total"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CO",
          caption: "CO",
          width: 50,
          fixed: true,
          "fixed-position": 'right',
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CM",
          caption: "CM",
          width: 50,
          fixed: true,
          "fixed-position": 'right',
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CFP",
          caption: "CFP",
          width: 50,
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "N",
          caption: "N",
          width: 45,
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "X",
          caption: "X",
          width: 45,
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "OreNelucrate",
          caption: "Ore Nelucr.",
          width: 90,
          alignment: "center",
          visible: _ctx.complet
        }, null, 8, ["visible"]),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSup50",
          caption: "Sup50",
          width: 60,
          alignment: "center",
          visible: _ctx.complet
        }, null, 8, ["visible"]),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSup100",
          caption: "Sup100",
          width: 60,
          alignment: "center",
          visible: _ctx.complet
        }, null, 8, ["visible"]),
        _createVNode(_component_DxColumn, {
          "data-field": "ValSupNoapte",
          caption: "Noapte",
          width: 60,
          alignment: "center",
          visible: _ctx.complet
        }, null, 8, ["visible"])
      ]),
      _: 1
    }, 8, ["data-source", "key-expr", "no-data-text"])
  ]))
}